<template>
  <div class="container">
  <div id="app" class="text-center">
        <router-view></router-view>
  </div>
</div>
</template>

<script>

/* eslint-disable */
import ChangePassword from './components/ChangePassword'

export default {
  name: 'app'
}
</script>




// WEBPACK FOOTER //
// src/App.vue